export default {

    data() {
        return {
            files: [],
        };
    },

    props: {
        slug: String,
        max: String,
        random: {
            type: String,
            default: 'false',
        },
    },

    mounted() {
        this.loadImages()
    },

    methods: {

        loadImages() {

            if (!this.slug) {
                console.error('Gallery key not defined. Add `slug="[slug]"` to the gallery tag.')
                return;
            }

            const data = {
                random: this.random,
            };

            if (this.max) {
                data.max = this.max;
            }

            const params = Object.keys(data).map((key) => {
                return key + '=' + data[key];
            });

            axios.get('/dynamic/collections/' + this.slug + '/by-slug?' + params.join('&'))
                .then(response => {
                    this.files = response.data.files;
                    if (this.filesLoaded) {
                        this.filesLoaded();
                    }
                })
                .catch(error => {
                    console.error(error);
                });

        }

    },

}
